import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import PageNotFound from '@/views/PageNotFound'

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters['auth/isAuthenticated']) next()
  else next('/play')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters['auth/isAuthenticated']) next()
  else next('/')
}

const ifAdmin = (to, from, next) => {
  if (store.getters['auth/isAdmin']) next()
  else next('/')
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/logout',
    //   name: 'logout',
    //   component: () => import('@/views/Logout'),
    //   beforeEnter: ifNotAuthenticated
    // },
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home'),
      beforeEnter: ifNotAuthenticated,
      redirect: {
        name: 'signin'
      },
      children: [
        {
          path: '/auth',
          name: 'auth',
          component: () => import('@/components/Auth')
        },
        {
          path: '/recover',
          name: 'recover',
          component: () => import('@/components/Recover')
        },
        {
          path: '/resend',
          name: 'resend',
          component: () => import('@/components/Resend')
        },
        {
          path: '/reset',
          name: 'reset',
          component: () => import('@/components/Reset')
        },
        {
          path: '/signin',
          name: 'signin',
          component: () => import('@/components/Signin')
        },
        {
          path: '/signup',
          name: 'signup',
          component: () => import('@/components/Signup')
        }
      ]
    },
    {
      path: '/dev',
      name: 'dev',
      component: () => import('@/views/Dev'),
      beforeEnter: ifAdmin
    },
    {
      path: '/play',
      name: 'play',
      component: () => import('@/views/Play'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '*',
      component: PageNotFound
    }
  ]
})
